// Thông tin kết nối Google Sheets API
const API_KEY = process.env.REACT_APP_API_KEY;
const SHEET_ID = process.env.REACT_APP_SHEET_ID;

// Hàm lấy dữ liệu từ Google Sheets
export const fetchSheetData = async () => {
  try {
    // Danh sách các sheet cần lấy dữ liệu
    const sheets = ["Info", "Teams", "Matches", "Standings", "Playoffs"];

    const sheetData = {};

    for (const sheet of sheets) {
      const response = await fetch(
        `https://sheets.googleapis.com/v4/spreadsheets/${SHEET_ID}/values/${sheet}?key=${API_KEY}`
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      sheetData[sheet] = data.values;
    }

    // Biến đổi dữ liệu từ Google Sheets
    return transformSheetData(sheetData);
  } catch (error) {
    console.error("Error fetching data from Google Sheets:", error);
    throw error;
  }
};

// Hàm biến đổi dữ liệu từ Google Sheets sang cấu trúc mà ứng dụng cần
const transformSheetData = (sheetData) => {
  // Bạn cần điều chỉnh logic chuyển đổi dựa trên cấu trúc của sheet của bạn
  // Đây là ví dụ dựa trên cấu trúc đã thấy trong hình

  const transformedData = {
    tournamentInfo: {
      name: "",
      date: "",
      location: "",
      organizerName: "",
    },
    groups: {
      A: {
        teams: [],
        matches: [],
        standings: [],
      },
      B: {
        teams: [],
        matches: [],
        standings: [],
      },
    },
    playoffs: {
      semifinals: [],
      thirdPlace: {},
      final: {},
    },
  };

  // Xử lý dữ liệu Info
  if (sheetData.Info && sheetData.Info.length > 1) {
    // Bỏ qua hàng tiêu đề
    const infoData = sheetData.Info.slice(1);
    const tournamentInfo = {
      name: "",
      date: "",
      location: "",
      organizerName: "",
    };
    infoData.forEach((row) => {
      if (!row || row.length < 1) return; // Bỏ qua hàng rỗng
      if (row[0] === "Tên giải") {
        tournamentInfo.name = row[1] || "";
        return;
      }
      if (row[0] === "Ngày") {
        tournamentInfo.date = row[1] || "";
        return;
      }
      if (row[0] === "Địa điểm") {
        tournamentInfo.location = row[1] || "";
        return;
      }
      if (row[0] === "Ban tổ chức") {
        tournamentInfo.organizerName = row[1] || "";
        return;
      }
    });

    transformedData.tournamentInfo = tournamentInfo;
  }

  // Xử lý dữ liệu Teams
  if (sheetData.Teams && sheetData.Teams.length > 1) {
    // Bỏ qua hàng tiêu đề
    const teamsData = sheetData.Teams.slice(1);

    teamsData.forEach((row) => {
      if (!row || row.length < 3) return; // Bỏ qua nếu thiếu dữ liệu

      const teamId = row[0];
      const player1 = row[1];
      const player2 = row[2];

      if (teamId.startsWith("A")) {
        transformedData.groups.A.teams.push({
          id: teamId,
          name: `Team ${teamId}`,
          player1: player1,
          player2: player2,
        });
      } else if (teamId.startsWith("B")) {
        transformedData.groups.B.teams.push({
          id: teamId,
          name: `Team ${teamId}`,
          player1: player1,
          player2: player2,
        });
      }
    });
  }

  // Xử lý dữ liệu Standings
  if (sheetData.Standings && sheetData.Standings.length > 1) {
    // Bỏ qua hàng tiêu đề
    const standingsData = sheetData.Standings.slice(1);

    standingsData.forEach((row) => {
      if (!row || row.length < 10) return; // Bỏ qua nếu thiếu dữ liệu

      const teamId = row[1];
      const standing = {
        teamId: teamId,
        played: parseInt(row[3]) || 0,
        won: parseInt(row[4]) || 0,
        lost: parseInt(row[5]) || 0,
        forfeited: parseInt(row[6]) || 0,
        pointsFor: parseInt(row[7]) || 0,
        pointsAgainst: parseInt(row[8]) || 0,
        points: parseInt(row[10]) || 0,
      };

      if (teamId.startsWith("A")) {
        transformedData.groups.A.standings.push(standing);
      } else if (teamId.startsWith("B")) {
        transformedData.groups.B.standings.push(standing);
      }
    });
  }

  // Xử lý dữ liệu Matches
  if (sheetData.Matches && sheetData.Matches.length > 1) {
    // Bỏ qua các hàng tiêu đề
    const matchesData = sheetData.Matches;

    // Mảng để theo dõi các trận đấu
    let currentGroup = "";
    let currentRound = 0;

    matchesData.forEach((row) => {
      if (!row || row.length < 1) return; // Bỏ qua hàng rỗng

      // Xác định nhóm và vòng đấu
      if (row[0] === "Trận đấu - Bảng A") {
        currentGroup = "A";
        return;
      } else if (row[0] === "Trận đấu - Bảng B") {
        currentGroup = "B";
        return;
      } else if (row[0] && row[0].startsWith("Vòng ")) {
        currentRound = parseInt(row[0].replace("Vòng ", "")) || 0;
        return;
      }

      // Xử lý dữ liệu trận đấu
      if (currentGroup && row.length >= 10) {
        const time = row[0] || "";
        const court = row[2] || "";
        const team1Id = row[3] || "";
        const team2Id = row[6] || "";
        const team1Score = row[5] || "";
        const team2Score = row[8] || "";
        const status = row[9] || "Scheduled";

        // Xác định đội thắng
        let winner = "";
        if (status === "Hoàn thành") {
          const scores1 = team1Score.split(",").map((s) => parseInt(s.trim()));
          const scores2 = team2Score.split(",").map((s) => parseInt(s.trim()));

          let team1Wins = 0;
          let team2Wins = 0;

          for (let i = 0; i < Math.min(scores1.length, scores2.length); i++) {
            if (scores1[i] > scores2[i]) team1Wins++;
            else if (scores2[i] > scores1[i]) team2Wins++;
          }

          if (team1Wins > team2Wins) winner = team1Id;
          else if (team2Wins > team1Wins) winner = team2Id;
        }

        const match = {
          id: `${team1Id}vs${team2Id}`,
          team1: team1Id,
          team2: team2Id,
          time: time,
          court: court,
          status:
            status === "Hoàn thành"
              ? "Completed"
              : status === "Đang diễn ra"
              ? "In Progress"
              : "Scheduled",
          // score: `${team1Score}, ${team2Score}`,
          score1: team1Score,
          score2: team2Score,
          round: currentRound,
          winner: winner,
        };

        if (currentGroup === "A") {
          transformedData.groups.A.matches.push(match);
        } else if (currentGroup === "B") {
          transformedData.groups.B.matches.push(match);
        }
      }
    });
  }

  // Xử lý dữ liệu Playoffs
  if (sheetData.Playoffs && sheetData.Playoffs.length > 1) {
    const playoffsData = sheetData.Playoffs.slice(1); // Bỏ qua hàng tiêu đề

    playoffsData.forEach((row) => {
      if (!row || row.length < 3) return; // Bỏ qua hàng rỗng

      const time = row[0] || "";
      const roundType = row[1] || "";
      const court = row[2] || "";
      const team1Id = row[3] || "";
      const team1Name = row[4] || "";
      const team1Score = row[5] || "";
      const team2Id = row[6] || "";
      const team2Name = row[7] || "";
      const team2Score = row[8] || "";
      const status = row[9] || "Scheduled";

      // Tạo đối tượng match playoff
      const match = {
        id:
          roundType === "Bán kết 1"
            ? "SF1"
            : roundType === "Bán kết 2"
            ? "SF2"
            : roundType === "Tranh hạng 3"
            ? "3P"
            : "F",
        time: time,
        court: court,
        team1: {
          id: team1Id,
          name: team1Name,
          player1: "",
          player2: "",
        },
        team2: {
          id: team2Id,
          name: team2Name,
          player1: "",
          player2: "",
        },
        status:
          status === "Hoàn thành"
            ? "Completed"
            : status === "Đang diễn ra"
            ? "In Progress"
            : "Scheduled",
        score: team1Score && team2Score ? `${team1Score}-${team2Score}` : "",
      };

      // Tìm thông tin VĐV từ danh sách teams
      if (team1Id) {
        const team = [
          ...transformedData.groups.A.teams,
          ...transformedData.groups.B.teams,
        ].find((t) => t.id === team1Id);
        if (team) {
          match.team1.player1 = team.player1;
          match.team1.player2 = team.player2;
        }
      }

      if (team2Id) {
        const team = [
          ...transformedData.groups.A.teams,
          ...transformedData.groups.B.teams,
        ].find((t) => t.id === team2Id);
        if (team) {
          match.team2.player1 = team.player1;
          match.team2.player2 = team.player2;
        }
      }

      // Thêm trận đấu vào playoffs
      if (roundType === "Bán kết 1") {
        transformedData.playoffs.semifinals[0] = match;
      } else if (roundType === "Bán kết 2") {
        transformedData.playoffs.semifinals[1] = match;
      } else if (roundType === "Tranh hạng 3") {
        transformedData.playoffs.thirdPlace = match;
      } else if (roundType === "Chung kết") {
        transformedData.playoffs.final = match;
      }
    });
  }

  return transformedData;
};
